export type MinuteRange = {
    start: number;
    end: number;
};

export function minutesOfDay(time: string): number {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
}

export function timeslotRange(timeslot: string): MinuteRange {
    const [start, end] = timeslot.split(' - ');
    return { start: minutesOfDay(start), end: minutesOfDay(end) };
}

export function availableWindows(timeslots: string[]): MinuteRange[] {
    const ranges = timeslots.map(timeslotRange).sort((first, second) => first.start - second.start);

    return ranges.reduce((windows: MinuteRange[], range) => {
        const last = windows[windows.length - 1];
        if (last && range.start <= last.end) {
            last.end = Math.max(last.end, range.end);
            return windows;
        }
        return [...windows, { ...range }];
    }, []);
}

export function nearestTimeslot(timeslots: string[], minute: number): string | null {
    let nearest: string | null = null;
    let nearestDistance = Infinity;

    for (const timeslot of timeslots) {
        const distance = Math.abs(timeslotRange(timeslot).start - minute);
        if (distance < nearestDistance) {
            nearest = timeslot;
            nearestDistance = distance;
        }
    }

    return nearest;
}

export function neighboringTimeslot(
    timeslots: string[],
    current: string,
    direction: 'earlier' | 'later'
): string {
    const sorted = [...timeslots].sort(
        (first, second) => timeslotRange(first).start - timeslotRange(second).start
    );
    const index = sorted.indexOf(current);
    const neighborIndex = direction === 'later' ? index + 1 : index - 1;

    return sorted[neighborIndex] || current;
}

export function bookingDuration(timeslot: string): { hours: number; minutes: number } {
    const { start, end } = timeslotRange(timeslot);
    const length = end - start;
    return { hours: Math.floor(length / 60), minutes: length % 60 };
}
